/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/breakpoint-change';
import './components/offcanvas';
import './components/fancybox';
import './components/footer-menus';
import './components/scroll-to-top';
import './components/navigation';
import './components/tabs';
import { initAccordions } from './components/accordions';
import DeepL from './components/deepl';

const deepL = new DeepL();
deepL.init();

initAccordions();

document.addEventListener('scroll', () => {
	document.body.classList[scrollY > 100 ? 'add' : 'remove']('has-scrolled');
});
